export const TICKET_STATUSES = [
    { v: "new", label: "Nuevo", color: "#2563EB" },
    { v: "open", label: "Abierto", color: "#DC2626" },
    { v: "pending", label: "Pendiente", color: "#F59E0B" },
    { v: "resolved", label: "Resuelto", color: "#16A34A" },
    { v: "closed", label: "Cerrado", color: "#737373" },
];

export const TICKET_PRIORITIES = [
    { v: "low", label: "Baja", color: "#737373" },
    { v: "medium", label: "Media", color: "#2563EB" },
    { v: "high", label: "Alta", color: "#F59E0B" },
    { v: "urgent", label: "Urgente", color: "#DC2626" },
];

export function statusMeta(v) { return TICKET_STATUSES.find((s) => s.v === v) || { v, label: v, color: "#737373" }; }
export function priorityMeta(v) { return TICKET_PRIORITIES.find((p) => p.v === v) || { v, label: v, color: "#737373" }; }

export const SLA_STATUS_META = {
    ok:       { label: "SLA al día", color: "#16A34A", icon: "✓" },
    warning:  { label: "SLA próximo", color: "#F59E0B", icon: "!" },
    breached: { label: "SLA vencido", color: "#DC2626", icon: "✕" },
    "n/a":    { label: "—", color: "#737373", icon: "·" },
};

export function formatSeconds(s) {
    if (s == null) return "—";
    if (s < 60) return `${s}s`;
    const m = Math.floor(s / 60), h = Math.floor(m / 60), d = Math.floor(h / 24);
    if (d >= 1) return `${d}d ${h % 24}h`;
    if (h >= 1) return `${h}h ${m % 60}m`;
    return `${m}m`;
}

export function formatDateShort(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    const now = new Date();
    const sameDay = d.toDateString() === now.toDateString();
    if (sameDay) return d.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" });
    return d.toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" });
}
